import { Injectable } from '@angular/core';
import { CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  ActivatedRoute,
  Router,
  CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './services/auth/auth.service.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationGuard implements CanActivate, CanActivateChild {
  constructor(
    private authorizationService: AuthService,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const allowedRoles = next.data.allowedRoles;
    const isAuthorized = this.authorizationService.isAuthenticated(allowedRoles);

    //console.log(next);

    if (!isAuthorized) {
      this.router.navigate(['./']);
    }

    return isAuthorized;
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const allowedRoles = next.data.allowedRoles;
    //console.log(next.data);
    const isAuthorized = this.authorizationService.isAuthenticated(allowedRoles);
    
    

    if (!isAuthorized) {
      // if not authorized, show access denied message
      this.router.navigate(['./']);
    }

    return isAuthorized;
  }
  
}
